var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelpCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.80423C5.9428 2.28906 4.75516 2 3.5 2C2.24484 2 1.0572 2.28906 0 2.80423V13.8042C1.0572 13.2891 2.24484 13 3.5 13C5.1686 13 6.71789 13.5108 8 14.3847C9.28211 13.5108 10.8314 13 12.5 13C13.7552 13 14.9428 13.2891 16 13.8042V2.80423C14.9428 2.28906 13.7552 2 12.5 2C11.2448 2 10.0572 2.28906 9 2.80423V11C9 11.5523 8.55229 12 8 12C7.44772 12 7 11.5523 7 11V2.80423Z",
    fill: "currentColor"
  })));
}

export default SvgHelpCenter;